import Icon from '../components/Icon.vue'

Icon.register({
  'hand-peace': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M408 216c22.1 0 40 17.9 40 40v80 0c0 2.6-0.5 6.7-1.1 9.2l-32 136c-4.3 18.1-20.4 30.8-38.9 30.8h-240 0c-12.8 0-28.4-9-34.7-20.2l-64-112c-9.8-17.1-5.6-38.8 9.7-51.1l31.1-24.9-74.8-190.3c-9.7-24.7 2.5-52.5 27.1-62.2 24.7-9.7 52.5 2.5 62.2 27.1l69.7 177.6h13.6v-208c0-26.5 21.5-48 48-48s48 21.5 48 48v208h8v-32c0-22.1 17.9-40 40-40s40 17.9 40 40v32h8c0-22.1 17.9-40 40-40z'
      }
    ]
  }
})
